/**
 * Royal Mandap Palace — Rajasthani palace plot-plane wedding journey.
 * Registered under id `royal-mandap-palace`.
 */
import React from 'react';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';
import { PlotPlaneWeddingExperience } from '@/src/modules/experiences/wedding/plotPlane/PlotPlaneWeddingExperience';
import { royalMandapPalaceTheme } from './theme';

const META: TemplateMetadata = {
  id: 'royal-mandap-palace',
  name: 'Royal Mandap Palace',
  occasionType: 'WEDDING',
  description:
    'A regal Rajasthani plot-plane journey: jharokha gate, courtyard blessings, mandap pheras, function arcade, and RSVP durbar — scroll-scrub depth with calm reduced-motion path.',
  isPremium: true,
  tags: ['wedding', 'rajasthani', 'palace', 'mandap', 'plot-plane', 'premium', 'interactive'],
  colorScheme: {
    primary: '#5b1030',
    accent: '#d4af37',
    bg: '#1a0812',
  },
};

export function RoyalMandapPalace({ data }: { data: InvitationData }) {
  return <PlotPlaneWeddingExperience data={data} theme={royalMandapPalaceTheme} />;
}

registry.register({ metadata: META, component: RoyalMandapPalace });
